'use strict'

TTD_CATEGORIES = ['things-to-do', 'fun-and-leisure-activities', 'kids-activities', 'nightlife', 'sightseeing-and-tours', 'sports-and-outdoor-activities', 'tickets-and-events']
TRENDING_RAPI_FILTER = 'data-embed-rapi-filter="badge_type:trending"'
{ isFeatureEnabled } = require '../helpers/finch'
isScrolledToElement = require '../helpers/is_scrolled_to_element'
{ getParameterByName } = require '../helpers/query_params'
{ addMouseDownListenerForCard } = require '../helpers/event_listener'

debounce = require '../helpers/debounce'

module.exports = class WidgetView
  constructor: (@options) ->
    @elementSelector = document.querySelector(@options.el)
    @retriever = @options.retriever
    @afterRender = @options.afterRender
    @load()

  load: ->
    @retriever.get({
      _csrf: @options._csrf
      _hasShownRVD: !!@options._hasShownRVD
      _isSearchPage: @_isSearchPage()
    }).then(
      (res) => @_handleBottomWidgetResponse res
      (err) -> # TODO
    )

  render: (widgetHtml) ->
    @elementSelector?.innerHTML = widgetHtml
    window.CardUI?.init('#pull-widget')
    allCards = document.querySelectorAll('#pull-widget .card-ui.cui-is-embedded-card:not(.has-location-rememberance-listener)')
    if allCards.length
      allCards.forEach(addMouseDownListenerForCard())

    if @afterRender
      @afterRender()

  _isSearchPage: ->
    getParameterByName('query') != null

  _isInUS: ->
    window.Groupon.division?.country is 'USA'

  _isTTDCategory: ->
    {category} = window.Groupon.Utils.unparam()
    TTD_CATEGORIES.indexOf(category) > -1

  _shouldRenderTopRatedWidget: ->
    @_isInUS() and isFeatureEnabled('showTopRatedCarousel') and @_isTTDCategory()

  _handleBottomWidgetResponse: (res) ->
    {bottomWidgetHtml, topRatedWidgetHtml, bCookieRVDWidgetHtml} = res
    isTrendingDealsWidget = bottomWidgetHtml?.includes(TRENDING_RAPI_FILTER)
    isBCookieRVDWidget = bCookieRVDWidgetHtml?

    if topRatedWidgetHtml
      if @_shouldRenderTopRatedWidget() then @render(topRatedWidgetHtml)
    else if isBCookieRVDWidget and isTrendingDealsWidget
      @_addBottomWidgetScrollListener('showBCookieBottomRVDDesktop')
      @render(bCookieRVDWidgetHtml)
    else if bottomWidgetHtml
      @render(bottomWidgetHtml)
      @_handleRVDWidgetViewAllLink() if not isTrendingDealsWidget

  _handleRVDWidgetViewAllLink: ->
    @_addBottomWidgetScrollListener('showLinkOnRvdDesktop')

  _addBottomWidgetScrollListener: (featureKey) ->
    if isScrolledToElement(@elementSelector)
      isFeatureEnabled(featureKey)
    else
      @_handleBottomWidgetBucketing = =>
        if isScrolledToElement(@elementSelector)
          isFeatureEnabled(featureKey)
          window.removeEventListener('scroll', @_onScrollForBottomWidget)

      @_onScrollForBottomWidget = debounce(@_handleBottomWidgetBucketing, 200)
      window.addEventListener('scroll', @_onScrollForBottomWidget)
